var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loading"},[_c('div',{staticClass:"mask",on:{"click":function($event){$event.stopPropagation();},"touchmove":function($event){$event.stopPropagation();$event.preventDefault();}}}),_c('loadingIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }